(function Captcha($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		var $captcha_div = $('.captcha'),
		    $spinner,
		    $img_div,
		    $img,
		    $refresh;

		// if captcha element appears on the page
		if ($captcha_div.length) {

			$spinner = $captcha_div.find('.captcha-spinner');
			$img_div = $captcha_div.find('.captcha-img');
			$img     = $('#captcha');
			$refresh = $captcha_div.find('.refresh-captcha');

			// set the img src
			$img.attr("src", Adzuki.base_uri + '/Main/captcha/?' + new Date().getTime());

			// show loading animation until image has loaded.  Once loaded, hide spinner and show img
			$img.on("load", function captchaLoaded() {
				$spinner.addClass('hidden');
				$img_div.removeClass('hidden');
			});

			// ability for user to click the reload icon and get a new captcha image. This will also end up resetting the session variable
			$refresh.on("click", function reloadCaptcha(e) {
				var $self = $(this),
				    $icon = $self.find('i');

				e.preventDefault();

				$icon.addClass('fa-spin');
				$img.attr("src", Adzuki.base_uri + '/Main/captcha/?' + new Date().getTime());

				$img.on("load", function captchaLoaded() {
					$icon.removeClass('fa-spin');
				});
			});
		}
	});
}(jQuery, window.Adzuki || {}));
